import React from 'react'
import '../styles/LiquidBlock.css'

const LiquidBlock = ({children, className}) => {
  return (
    <div className={`LiqBlock ${className || ''}`}>
        <div className='LiqBlockBg'>
            {children}
        </div>
    </div>
  )
}

export default LiquidBlock